import produce from "immer";
import { LoadState } from "../../constants/enums";
import {
  ICustomerPolicyDetailsState,
  initialCustomerPolicyDetails,
} from "./customerPolicyDetails.types";
import { CustomerPolicyDetailsAction } from ".";
import {
  CLEAR_CUSTOMER_POLICY_DETAILS_STATE,
  FETCH_CUSTOMER_POLICY_DETAILS_FAILED,
  FETCH_CUSTOMER_POLICY_DETAILS_PROGRESS,
  FETCH_CUSTOMER_POLICY_DETAILS_SUCCESS,
} from "./customerPolicyDetailsActions";

export const customerPolicyDetailsReducer = (
  state: ICustomerPolicyDetailsState = initialCustomerPolicyDetails,
  action: CustomerPolicyDetailsAction
): ICustomerPolicyDetailsState => {
  switch (action.type) {
    case FETCH_CUSTOMER_POLICY_DETAILS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.details.loading = LoadState.InProgress;
        draftState.details.data = initialCustomerPolicyDetails.details.data;
        draftState.details.error = null;
      });
      return newState;
    }
    case FETCH_CUSTOMER_POLICY_DETAILS_SUCCESS: {
      const { details, customerPolicyId, isNewPolicy } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.details.loading = LoadState.Loaded;
        draftState.details.data = details;
        draftState.details.error = null;
        draftState.customerPolicyId = customerPolicyId;
        draftState.isNewPolicy = isNewPolicy;
      });
      return newState;
    }
    case FETCH_CUSTOMER_POLICY_DETAILS_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.details.loading = LoadState.Failed;
        draftState.details.error = errorMessage;
        draftState.details.data = initialCustomerPolicyDetails.details.data;
      });
      return newState;
    }
    case CLEAR_CUSTOMER_POLICY_DETAILS_STATE: {
      return initialCustomerPolicyDetails;
    }
    default: {
      return state;
    }
  }
};
